import gql from 'graphql-tag'

export const GetPastaPermissaoEscritaQueryName = 'GetPastaPermissaoEscritaQuery'
export const PASTAS_PERMISSAO_ESCRITA = gql`
  query GetPastaPermissaoEscritaQuery {
    pastasComPermissaoEscrita {
      id
      nome
    }
  }
`
